import { Injectable } from '@angular/core';
import _merge from 'lodash.merge';

@Injectable({
  providedIn: 'root'
})
export class TableHeaderService {

  constructor() { }

  id(config?) {
    return this.merge({
      key: 'id',
      name: 'ID',
      filter: {
        key: 'id',
        type: 'number',
        placeholder: 'ID'
      },
      sort: {
        key: 'id'
      },
      class: 'min-width-120'
    }, config);
  }

  userId(config?) {
    return this.merge({
      key: 'userId',
      name: 'User ID',
      filter: {
        key: 'userId',
        type: 'number',
        placeholder: 'ID'
      },
      sort: {
        key: 'userId'
      },
      class: 'min-width-120'
    }, config);
  }

  name(config?) {
    return this.merge({
      key: 'name',
      name: 'Name',
      filter: {
        key: 'name',
        type: 'text',
        placeholder: 'Name'
      },
      sort: {
        key: 'name'
      },
      class: 'min-width-120'
    }, config);
  }

  description(config?) {
    return this.merge({
      key: 'description',
      name: 'Description',
      filter: {
        key: 'description',
        type: 'text',
        placeholder: 'Awesome app'
      },
      sort: {
        key: 'description'
      },
      class: 'min-width-120'
    }, config);
  }

  storeGroup(config?) {
    return this.merge({
      key: 'storeGroup',
      name: 'Group',
      filter: {
        key: 'storeGroup',
        type: 'text',
        placeholder: 'Name'
      },
      sort: {
        key: 'storeGroup'
      },
      class: 'min-width-120'
    }, config);
  }

  moderator(config?) {
    return this.merge({
      key: 'moderator',
      name: 'Moderator',
      filter: {
        key: 'moderator',
        type: 'text',
        placeholder: 'Name'
      },
      sort: {
        key: 'moderator'
      },
      class: 'min-width-120'
    }, config);
  }

  key(config?) {
    return this.merge({
      key: 'key',
      name: 'Key',
      filter: {
        key: 'key',
        type: 'text',
        placeholder: 'Key'
      },
      sort: {
        key: 'key'
      },
      class: 'min-width-120'
    }, config);
  }


  createdAt(config?) {
    return this.merge({
      key: 'createdAt',
      name: 'Date created',
      filter: {
        key: 'createdAt',
        type: 'date',
        placeholder: 'Date created'
      },
      sort: {
        key: 'createdAt'
      },
      class: 'min-width-160'
    }, config);
  }

  updatedAt(config?) {
    return this.merge({
      key: 'updatedAt',
      name: 'Date updated',
      filter: {
        key: 'updatedAt',
        type: 'date',
        placeholder: 'Date updated'
      },
      sort: {
        key: 'updatedAt'
      },
      class: 'min-width-160'
    }, config);
  }

  expiredAt(config?) {
    return this.merge({
      key: 'expiredAt',
      name: 'Date expired',
      filter: {
        key: 'expiredAt',
        type: 'date',
        placeholder: 'Date expired'
      },
      sort: {
        key: 'expiredAt'
      },
      class: 'min-width-160'
    }, config);
  }

  authAt(config?) {
    return this.merge({
      key: 'authAt',
      name: 'Last auth.',
      filter: {
        key: 'authAt',
        type: 'date',
        placeholder: 'Last auth.'
      },
      sort: {
        key: 'authAt',
      },
      class: 'min-width-160'
    }, config);
  }

  usedAt(config?) {
    return this.merge({
      key: 'usedAt',
      name: 'Date last used',
      filter: {
        key: 'usedAt',
        type: 'date',
        placeholder: 'Date last used'
      },
      sort: {
        key: 'usedAt',
      },
      class: 'min-width-160'
    }, config);
  }

  account(config?) {
    return this.merge({
      key: 'account',
      name: 'Account',
      filter: {
        key: 'account',
        type: 'text',
        placeholder: 'e-mail'
      },
      sort: {
        key: 'account'
      },
      class: 'min-width-120'
    }, config);
  }

  email(config?) {
    return this.merge({
      key: 'email',
      name: 'E-mail',
      filter: {
        key: 'email',
        type: 'text',
        equals: true,
        placeholder: 'E-mail'
      },
      sort: {
        key: 'email'
      },
      class: 'min-width-120'
    }, config);
  }

  provider(config?) {
    return this.merge({
      key: 'provider',
      name: 'OAuth',
      filter: {
        key: 'OAuthProvider',
        type: 'text',
        placeholder: 'OAuth'
      },
      sort: {
        key: 'OAuthProvider'
      },
      class: 'min-width-120'
    }, config);
  }

  store(config?) {
    return this.merge({
      key: 'store',
      name: 'Store',
      filter: {
        entity: 'store',
        key: 'store',
        type: 'select',
        storeQuery: null,
        placeholder: 'Name'
      },
      sort: {
        key: 'store'
      },
      class: 'min-width-120'
    }, config);
  }

  user(config?) {
    return this.merge({
      key: 'user',
      name: 'User',
      filter: {
        key: 'user',
        type: 'text',
        placeholder: 'Name'
      },
      sort: {
        key: 'user'
      },
      class: 'min-width-120'
    }, config);
  }

  users(config?) {
    return this.merge({
      key: 'users',
      name: 'Users',
      filter: {
        key: 'user',
        type: 'number',
        placeholder: 'User'
      },
      sort: {
        key: 'users'
      },
      class: 'min-width-120'
    }, config);
  }

  device(config?) {
    return this.merge({
      key: 'device',
      name: 'Device',
      filter: {
        key: 'device',
        type: 'text',
        placeholder: 'Device'
      },
      sort: {
        key: 'device'
      },
      class: 'min-width-120'
    }, config);
  }

  product(config?) {
    return this.merge({
      key: 'product',
      name: 'Product',
      filter: {
        key: 'product',
        entity: 'product',
        type: 'select',
        placeholder: 'Product'
      },
      sort: {
        key: 'product'
      },
      class: 'min-width-120'
    }, config);
  }

  action(config?) {
    return this.merge({
      key: 'action',
      name: 'Action',
      filter: {
        key: 'action',
        type: 'text',
        placeholder: 'Action'
      },
      sort: {
        key: 'action'
      },
      class: 'min-width-120'
    }, config);
  }

  purchase(config?) {
    return this.merge({
      key: 'purchase',
      name: 'Purchase',
      filter: {
        key: 'purchase',
        type: 'text',
        placeholder: 'Purchase'
      },
      sort: {
        key: 'purchase'
      },
      class: 'min-width-120'
    }, config);
  }

  value(config?) {
    return this.merge({
      key: 'value',
      name: 'Value',
      filter: {
        key: 'value',
        type: 'text',
        placeholder: 'Value'
      },
      sort: {
        key: 'value'
      },
      class: 'min-width-120'
    }, config);
  }

  diff(config?) {
    return this.merge({
      key: 'diff',
      name: 'Difference',
      filter: {
        key: 'diff',
        type: 'text',
        placeholder: '0'
      },
      sort: {
        key: 'diff'
      },
      class: 'min-width-120'
    }, config);
  }

  count(config?) {
    return this.merge({
      key: 'count',
      name: 'Count',
      filter: {
        key: 'count',
        type: 'text',
        placeholder: 'Count'
      },
      sort: {
        key: 'count'
      },
      class: 'min-width-120'
    }, config);
  }

  products(config?) {
    return this.merge({
      key: 'products',
      name: 'Products',
      filter: {
        key: 'products',
        type: 'text',
        placeholder: 'Products'
      },
      sort: {
        key: 'products'
      },
      class: 'min-width-120'
    }, config);
  }

  storeCollections(config?) {
    return this.merge({
      key: 'storeCollections',
      name: 'Collections',
      filter: {
        key: 'storeCollections',
        type: 'text',
        placeholder: 'Collections'
      },
      sort: {
        key: 'storeCollections'
      },
      class: 'min-width-120'
    }, config);
  }

  projects(config?) {
    return this.merge({
      key: 'projects',
      name: 'Projects',
      filter: {
        key: 'projects',
        type: 'text',
        placeholder: 'Projects'
      },
      sort: {
        key: 'projects'
      },
      class: 'min-width-120'
    }, config);
  }

  platform(config?) {
    return this.merge({
      key: 'platform',
      name: 'Platform',
      filter: {
        key: 'platform',
        type: 'text',
        placeholder: 'Platform'
      },
      sort: {
        key: 'platform'
      },
      class: 'min-width-120'
    }, config);
  }

  price(config?) {
    return this.merge({
      key: 'price',
      name: 'Price',
      filter: {
        key: 'price',
        type: 'number',
        placeholder: 'Price',
      },
      sort: {
        key: 'price'
      },
      class: 'min-width-120'
    }, config);
  }

  info(config?) {
    return this.merge({
      key: 'info',
      name: 'Info',
      filter: {
        key: 'info',
        type: 'text',
        placeholder: 'Info'
      },
      sort: {
        key: 'info'
      },
      class: 'min-width-120'
    }, config);
  }

  currency(config?) {
    return this.merge({
      key: 'currency',
      name: 'Currency',
      filter: {
        key: 'currency',
        type: 'select',
        options: [{
          label: '₽',
          value: '₽'
        }, {
          label: '$',
          value: '$'
        }],
        placeholder: 'All',
      },
      sort: {
        key: 'currency'
      },
      class: 'min-width-120'
    }, config);
  }

  receipt(config?) {
    return this.merge({
      key: 'receipt',
      name: 'Receipt',
      filter: {
        key: 'value',
        type: 'text',
        placeholder: '#'
      },
      sort: {
        key: 'value'
      },
      class: 'min-width-120'
    }, config);
  }

  force(config?) {
    return this.merge({
      key: 'force',
      name: 'Force',
      filter: {
        key: 'force',
        type: 'select',
        options: [{
          label: 'Force',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'force'
      },
      class: 'min-width-120'
    }, config);
  }

  failed(config?) {
    return this.merge({
      key: 'failed',
      name: 'Failed',
      filter: {
        key: 'failed',
        type: 'select',
        options: [{
          label: 'Failed',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'failed'
      },
      class: 'min-width-120'
    }, config);
  }

  innerPurchase(config?) {
    return this.merge({
      key: 'innerPurchase',
      name: 'Inner purchase',
      filter: {
        key: 'innerPurchase',
        type: 'select',
        options: [{
          label: 'Inner',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'innerPurchase'
      },
      class: 'min-width-120'
    }, config);
  }

  json(config?) {
    return this.merge({
      key: 'json',
      name: 'JSON',
      filter: false,
      sort: false,
      class: 'min-width-300'
    }, config);
  }

  completed(config?) {
    return this.merge({
      key: 'completed',
      name: 'Completed',
      filter: {
        key: 'completed',
        type: 'select',
        options: [{
          label: 'Completed',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'completed'
      },
      class: 'min-width-120'
    }, config);
  }

  validated(config?) {
    return this.merge({
      key: 'validated',
      name: 'Validated',
      filter: {
        key: 'validated',
        type: 'select',
        options: [{
          label: 'Validated',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'validated'
      },
      class: 'min-width-120'
    }, config);
  }

  checked(config?) {
    return this.merge({
      key: 'checked',
      name: 'Checked',
      filter: {
        key: 'checked',
        type: 'select',
        options: [{
          label: 'Checked',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'checked'
      },
      class: 'min-width-120'
    }, config);
  }

  sandBox(config?) {
    return this.merge({
      key: 'sandBox',
      name: 'SandBox',
      filter: {
        key: 'sandBox',
        type: 'select',
        options: [{
          label: 'SandBox',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'sandBox'
      },
      class: 'min-width-120'
    }, config);
  }


  originalTransactionId(config?) {
    return this.merge({
      key: 'originalTransactionId',
      name: 'Transaction ID',
      filter: {
        key: 'originalTransactionId',
        type: 'text',
        placeholder: '#'
      },
      sort: {
        key: 'originalTransactionId'
      },
      class: 'min-width-120'
    }, config);
  }
  moderatorId(config?) {
    return this.merge({
      key: 'moderator',
      name: 'Moderator ID',
      filter: {
        key: 'moderator',
        type: 'number',
        placeholder: '#'
      },
      sort: {
        key: 'moderator'
      },
      class: 'min-width-120'
    }, config);
  }

  innerProduct(config?) {
    return this.merge({
      key: 'innerProduct',
      name: 'Inner product',
      filter: {
        key: 'innerProduct',
        type: 'select',
        options: [{
          label: 'Inner',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'innerProduct'
      },
      class: 'min-width-120'
    }, config);
  }

  active(config?) {
    return this.merge({
      key: 'active',
      name: 'Active',
      filter: {
        key: 'active',
        type: 'select',
        options: [{
          label: 'Active',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'active'
      },
      class: 'min-width-150'
    }, config);
  }

  availableForDownloading(config?) {
    return this.merge({
      key: 'availableForDownloading',
      name: 'Available for downloading',
      filter: {
        key: 'availableForDownloading',
        type: 'select',
        options: [{
          label: 'Available',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'availableForDownloading'
      },
      class: 'min-width-150'
    }, config);
  }

  free(config?) {
    return this.merge({
      key: 'free',
      name: 'Free',
      filter: {
        key: 'free',
        type: 'select',
        options: [{
          label: 'Free',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        placeholder: 'All'
      },
      sort: {
        key: 'free'
      },
      class: 'min-width-150'
    }, config);
  }

  subject(config?) {
    return this.merge({
      key: 'subject',
      name: 'Subject',
      filter: {
        key: 'subject',
        type: 'text',
        placeholder: 'Subject'
      },
      sort: {
        key: 'subject'
      },
      class: 'min-width-120'
    }, config);
  }

  market(config?) {
    return this.merge({
      key: 'market',
      name: 'Market',
      filter: {
        key: 'market',
        type: 'select',
        options: [{
          label: 'iOS',
          value: 1
        }, {
          label: 'Android',
          value: 2
        }],
        placeholder: 'All',
      },
      sort: {
        key: 'market'
      },
      class: 'min-width-120'
    }, config);
  }

  type(config?) {
    return this.merge({
      key: 'type',
      name: 'Type',
      filter: {
        key: 'type',
        type: 'select',
        placeholder: 'Type',
        equals: true,
        options: [{
          label: 'Subscription',
          value: 'Subscription'
        }, {
          label: 'Consumable',
          value: 'Consumable'
        }, {
          label: 'NonConsumable',
          value: 'NonConsumable'
        }],
      },
      sort: {
        key: 'type'
      },
      class: 'min-width-120'
    }, config);
  }

  productType(config?) {
    return this.merge({
      key: 'productType',
      name: 'Product type',
      filter: {
        key: 'productType',
        type: 'select',
        equals: true,
        placeholder: 'Product type',
        options: [{
          label: 'Subscription',
          value: 'Subscription'
        }, {
          label: 'Consumable',
          value: 'Consumable'
        }, {
          label: 'NonConsumable',
          value: 'NonConsumable'
        }],
      },
      sort: {
        key: 'productType'
      },
      class: 'min-width-150'
    }, config);
  }

  version(config?) {
    return this.merge({
      key: 'version',
      name: 'Version',
      filter: {
        key: 'version',
        type: 'text',
        placeholder: 'Version'
      },
      sort: {
        key: 'version'
      },
      class: 'min-width-120'
    }, config);
  }

  stores(config?) {
    return this.merge({
      key: 'stores',
      name: 'Stores',
      filter: {
        key: 'stores',
        type: 'text',
        placeholder: 'Store',
      },
      sort: {
        key: 'stores'
      },
      class: 'min-width-120'
    }, config);
  }

  coins(config?) {
    return this.merge({
      key: 'coins',
      name: 'Coins change',
      class: 'min-width-150'
    }, config);
  }

  actions(config?) {
    return this.merge({
      key: 'actions',
      name: '',
      class: 'w-1'
    }, config);
  }

  merge(header, config = {}) {
    return _merge({}, header, config);
  }

  add(headers, header, position = headers.length) {
    headers.splice(position, 0, header);
  }

  remove(headers, key) {
    const index = headers.findIndex(item => item.key === key);
    // headers.splice(index, 1);
    if (~index)
      headers.splice(index, 1);
  }
}
